export const buildColumnDefs = ({ schema, registry = {} }) => {
    if (!schema?.cols) return [];

    const storedCols =
        typeof schema.cols === 'string'
            ? JSON.parse(schema.cols)
            : schema.cols;

    if (!Array.isArray(storedCols)) return [];

    return storedCols.map((col) => {
        const base = {
            field: col.field,
            headerName: col.headerName,
            width: col.width ?? 120,
            flex: col.flex,
            minWidth: col.minWidth,
            maxWidth: col.maxWidth,
            hideable: col.hideable,
            sortable: col.sortable,
            filterable: col.filterable,
            align: col.align,
            headerAlign: col.headerAlign,

            // important: expose helperOptions on the final colDef
            helperOptions: col.helperOptions || {},
        };

        const typeHelpers = registry[col.type] || {};

        return {
            ...base,
            ...typeHelpers,
            ...col.overrides,
        };
    });
};